import { Button, Col, Container, Modal, Row } from 'react-bootstrap';

import CloseButton from '../Styled/CloseButton';
import ErrorDisc from '../../assets/svg/disc/error-disc.svg';
import React from 'react';
import { SpacerHr } from '../Styled';
import { contentfulPropTypes } from '../../propTypes';
import styled from 'styled-components';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledHeader = styled(Modal.Header)`
  position: absolute;
  right: 0;
  z-index: 1000;
`;

const NetZeroEnergyWarningModal = ({
  contentful,
  loading,
  fetched,
  show,
  onClose,
  onContinue,
}) =>
  !loading &&
  fetched && (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onClose}>
      <StyledHeader>
        <CloseButton onClick={onClose} variant={'bordered'} />
      </StyledHeader>
      <Modal.Body className="pt-0">
        <Container fluid>
          <Row>
            <Col className="mt-4 text-center">
              <img alt="Error disc" src={ErrorDisc} />
              <h1 className="pt-4 pb-3">{contentful?.title}</h1>
              <p>{contentful?.subtitle}</p>
              <Button
                variant="primary"
                onClick={onClose}
                className="my-3 px-5 w-100">
                {contentful.primaryButtonText}
              </Button>
              <SpacerHr label="or" />
              <Button
                variant="outline-secondary"
                onClick={onContinue}
                className="my-3 px-5 w-100">
                {contentful.secondaryButtonText}
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );

NetZeroEnergyWarningModal.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(
  NetZeroEnergyWarningModal,
  'web_app_net_zero_energy_warning_modal',
);
